import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HospitalGroupContractListsComponent } from './hospital-group-contract-lists.component';
import { AngularMaterialModule } from '../../../angular-material/angular-material.module';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { InlineSVGModule } from "ng-inline-svg";
import { PipesModule } from "../../../pipes/index";



@NgModule({
  declarations: [HospitalGroupContractListsComponent],
  imports: [
    CommonModule,
    AngularMaterialModule,
    FormsModule, ReactiveFormsModule,
    InlineSVGModule, PipesModule
  ],
  exports: [HospitalGroupContractListsComponent]
})
export class HospitalGroupContractListsModule { }
